<template>
  <div>
    <div class="field">
      <label class="field__label">קישור YouTube <span class="req">*</span></label>
      <div class="field--has-prefix">
        <span class="prefix"><LtIcon name="youtube" :size="18" /></span>
        <input v-model="form.youtube" class="input input--with-prefix" placeholder="https://youtu.be/dQw4w9WgXcQ" />
      </div>
      <span class="field__hint">אפשר להזין כתובת מלאה או רק את קוד הסרטון. הסרטון יופיע בעמוד הלינקטון.</span>
    </div>

    <div v-if="hasVideo && videoId" class="yt-preview">
      <img :src="'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg'" :alt="form.name" @error="onImgError" />
      <div class="yt-preview__play"><span><LtIcon name="play" :size="22" /></span></div>
    </div>
    <div v-else class="empty" style="margin-top: 10px">
      <div class="empty__icon"><LtIcon name="youtube" :size="24" /></div>
      <div class="empty__title">עדיין אין קליפ</div>
      <div>הלינקטון יעבוד גם בלי וידאו — אפשר להוסיף בכל שלב.</div>
    </div>
  </div>
</template>

<script>
import LtIcon from '../LtIcon.vue';
import { wizardFormInject } from '../wizardInject.js';

export default {
  name: 'StepVideo',
  mixins: [wizardFormInject],
  components: { LtIcon },
  computed: {
    hasVideo() {
      return this.form.youtube && this.form.youtube.length > 5;
    },
    videoId() {
      const s = this.form.youtube || '';
      const m = s.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
      if (m) return m[1];
      if (/^[A-Za-z0-9_-]{6,}$/.test(s.trim())) return s.trim();
      return null;
    },
  },
  methods: {
    onImgError(e) {
      e.target.style.display = 'none';
    },
  },
};
</script>
